import {useState} from "react";
import {LogIn, ArrowUpRight} from "lucide-react";
import {apiPost} from "@/lib/api";
import {FormModal} from "@/components/UI";

export default function AuthModal({close, setUser, notify, inline = false}) {
  const [mode, setMode] = useState("login");
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await apiPost(`/auth/${mode}`, {email, password, name});
      setUser(r); close();
      notify("Padharo! Welcome to Indian Ocean");
    } catch { notify("Please check your details and try again"); }
  };

  const google = () => {
    const redirectUrl = window.location.origin + window.location.pathname;
    /* REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH */
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const body = (
    <>
      <p className="modal-sub">Sign up or sign in with your Google account — it takes a few seconds.</p>
      <button data-testid="google-signin" className="coral-button full google-primary" onClick={google}>Continue with Google <ArrowUpRight size={15}/></button>
      {!showEmail ? (
        <button data-testid="auth-show-email" className="switch-auth" onClick={() => setShowEmail(true)}>Use email instead</button>
      ) : (
        <>
          <form onSubmit={submit}>
            {mode === "register" && <input data-testid="auth-name" required placeholder="Your name" value={name} onChange={e => setName(e.target.value)}/>}
            <input data-testid="auth-email" required type="email" placeholder="Email address" value={email} onChange={e => setEmail(e.target.value)}/>
            <input data-testid="auth-password" required type="password" placeholder="Password (min 6 chars)" value={password} onChange={e => setPassword(e.target.value)}/>
            <button data-testid="auth-submit" className="outline-button full" type="submit">{mode === "login" ? "Sign in" : "Create account"} <LogIn size={16}/></button>
          </form>
          <button data-testid="auth-toggle" className="switch-auth" onClick={() => setMode(mode === "login" ? "register" : "login")}>
            {mode === "login" ? "New here? Create an account" : "Already a member? Sign in"}
          </button>
        </>
      )}
    </>
  );

  if (inline) return <div className="auth-inline" data-testid="auth-inline"><div className="eyebrow">WELCOME TO INDIAN OCEAN</div><h2>{mode === "login" ? "Sign in to continue." : "Create your account."}</h2>{body}</div>;
  return <FormModal title="Good to see you." eyebrow="WELCOME TO INDIAN OCEAN" close={close} width={420} testId="auth-modal">{body}</FormModal>;
}
